export const getters = {
    list: state => state.list,
    defect: state => state.defect,
    allDefect: state => state.allDefect,
    dateList: state => state.dateList,
    lastHistory: state => state.lastHistory,
    selectedHistory: state => state.selectedHistory,
    
    inventory: state => state.inventory,
    columns: state => state.columns,
    model: state => state.model,
    filter: state => state.filter,
    pagination: state => state.pagination,
    sort: state => state.sort,
    rules: state => state.rules,
};
